import * as React from 'react'
import { SVGProps } from 'react'

const SvgDemoBitcoinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect width={32} height={32} rx={16} fill='url(#DemoBitcoinIcon_svg__a)' />
    <path
      d='M3.451 13.7V20h2.52c.873 0 1.593-.297 2.178-.9s.882-1.359.882-2.25-.297-1.638-.882-2.241c-.585-.603-1.305-.909-2.178-.909h-2.52Zm1.44 4.914v-3.528h1.08c.495 0 .9.162 1.206.486.315.315.468.747.468 1.278s-.153.963-.468 1.287c-.306.315-.71.477-1.206.477h-1.08Zm6.57-1.116h2.25V16.13h-2.25v-1.044h2.475V13.7H10.02V20h3.96v-1.386h-2.52v-1.116Zm8.372-3.798-1.71 2.799-1.71-2.799h-1.44V20h1.44v-3.663l1.63 2.673h.161l1.63-2.673V20h1.44v-6.3h-1.44Zm8.031 5.481c.64-.63.954-1.404.954-2.331s-.315-1.701-.954-2.331c-.639-.63-1.413-.945-2.322-.945s-1.683.315-2.322.945c-.639.63-.954 1.404-.954 2.331s.315 1.701.954 2.331c.64.63 1.413.945 2.322.945.91 0 1.683-.315 2.322-.945Zm-3.636-.981c-.35-.351-.522-.801-.522-1.35s.171-.999.522-1.35c.351-.351.792-.522 1.314-.522s.954.171 1.305.522.531.801.531 1.35-.18.999-.53 1.35c-.352.351-.784.522-1.306.522s-.963-.171-1.314-.522Z'
      fill='#fff'
    />
    <defs>
      <linearGradient id='DemoBitcoinIcon_svg__a' x1={-3.5} y1={29.5} x2={18.5} y2={37} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#3179FF' />
        <stop offset={1} stopColor='#4FB8E9' />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgDemoBitcoinIcon
